
function WorkInProgress2() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 32 32"
      fill="none"
    >
      <g clip-path="url(#clip0_2774_2326)">
        <path
          d="M30.0237 17.2889C30.0237 25.0339 23.7451 31.3125 16.0001 31.3125C8.25513 31.3125 1.97656 25.0339 1.97656 17.2889C1.97656 9.54394 8.25512 3.26538 16.0001 3.26538L17.7092 3.26538"
          stroke="#DB8400"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.1367 0.687023L17.7146 3.2649L15.1367 5.84277"
          stroke="#DB8400"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <circle
          cx="22"
          cy="4"
          r="1"
          transform="rotate(-90 22 4)"
          fill="#DB8400"
        />
        <circle
          cx="26"
          cy="6"
          r="1"
          transform="rotate(-90 26 6)"
          fill="#DB8400"
        />
        <circle
          cx="29"
          cy="9.5"
          r="1"
          transform="rotate(-90 29 9.5)"
          fill="#DB8400"
        />
        <circle
          cx="30"
          cy="14"
          r="1"
          transform="rotate(-90 30 14)"
          fill="#DB8400"
        />
        <g clip-path="url(#clip1_2774_2326)">
          <path
            d="M19.9286 17.9828C21.503 17.728 23.1309 17.4645 24.0922 15.7996L25.4375 13.4694L15.1523 7.53125L13.807 9.86148C12.8458 11.5264 13.4316 13.068 13.9981 14.5589C14.2717 15.2789 14.5546 16.0234 14.6617 16.7824C14.6707 16.85 14.6185 17.1228 14.4052 17.4922C14.1919 17.8617 13.9818 18.0432 13.9187 18.0693C13.2078 18.356 12.4216 18.4833 11.6613 18.6063C10.0869 18.8611 8.45892 19.1246 7.4977 20.7895L6.15234 23.1197L16.4375 29.0579L17.7829 26.7276C18.7441 25.0627 18.1583 23.5211 17.5918 22.0302C17.3182 21.3102 17.0353 20.5657 16.9281 19.8067C16.9192 19.7391 16.9714 19.4663 17.1847 19.0969C17.398 18.7274 17.6081 18.5459 17.6711 18.5198C18.382 18.2332 19.1682 18.1059 19.9286 17.9828ZM15.8256 19.9624C15.9502 20.8448 16.2556 21.6485 16.551 22.4257C17.0685 23.7877 17.5155 24.964 16.8186 26.1709L16.03 27.5369L7.67328 22.7122L8.46194 21.3462C9.15878 20.1392 10.4009 19.9381 11.8392 19.7054C12.66 19.5725 13.5087 19.4352 14.3351 19.1019C15.0743 18.8038 15.8757 17.4159 15.7642 16.6267C15.6396 15.7443 15.3342 14.9406 15.0388 14.1634C14.5213 12.8014 14.0744 11.6251 14.7712 10.4182L15.5599 9.05219L23.9166 13.8769L23.1279 15.2429C22.4311 16.4499 21.1889 16.651 19.7506 16.8837C18.9298 17.0166 18.0811 17.154 17.2547 17.4872C16.5155 17.7853 15.7142 19.1732 15.8256 19.9624Z"
            fill="#DB8400"
          />
          <path
            d="M15.5288 24.2468L15.5295 22.1027L10.2178 22.4662L14.9721 25.211L15.5288 24.2468Z"
            fill="#DB8400"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2774_2326">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(0 32) rotate(-90)"
          />
        </clipPath>
        <clipPath id="clip1_2774_2326">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(12.5 6) rotate(30)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default WorkInProgress2;
